import React, { useState, useEffect } from 'react'
import './nav.css'
import useAuth from '../../hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import axios from '../../api/axios';
import useIsMobile from '../../hooks/useIsMobile';
import NavItems from './NavItems';
import NavItemsMobile from './NavItemsMobile';
import { Link } from 'react-router-dom';
import { defaultLanguage } from "../../constants";

const LANG_URL = '/contact';
const WEBSITE_URL = '/websiteAuth/calendar';
const DASH_URL = '/dashboard';

export default function Nav() {
  //hooks
  const art = defaultLanguage;
  const title = "accomodationForm";
  const { i18n } = useTranslation();
  const { auth, username } = useAuth();
  const [languages, setLanguages] = useState([]);
  const isMobile = useIsMobile();
  const [calendar, setCalendar] = useState([]);
  const [showSpecialOffers, setShowSpecialOffers] = useState(true);
  const [showBlogs, setShowBlogs] = useState(true);

  useEffect(() => {
    const getContent = async () => {
      await axios.get(`${WEBSITE_URL}`, {
        params: { username },
      }).then((res) => {
        setCalendar(res?.data?.calendar);
      }).catch((err) => {
        console.log(err);
      });
      axios.get(`${LANG_URL}`, {
        params: { username, art: "nl", title: "contact" },
      }).then((res) => {
        setLanguages(res?.data?.entry?.languages?.split(","));
      }).catch((err) => {
        console.log(err);
      });
      axios.get(`${DASH_URL}`, {
        params: { username, art, title },
      }).then((res) => {
        setShowSpecialOffers(res?.data?.entry?.showSpecialOffers);
        setShowBlogs(res?.data?.entry?.showBlogs);
      }).catch((err) => {
        console.log(err);
      });
    };
    getContent();
  }, [username, art]);

  return (
    <div>
      <ul>
        <div className="navbar">
          {isMobile ? (
            <NavItemsMobile isAdmin={auth.role} calendarUrl={calendar} />
          ) : (
            <NavItems isAdmin={auth.role} calendarUrl={calendar} showSpecialOffers={showSpecialOffers} showBlogs={showBlogs} />
          )}
          <li className="dropdown">
            <div className="nav-link">
              {!isMobile && (
                <div style={{ display: "inline-flex" }}>
                  {i18n.language}
                  <span className="hspace"></span>
                </div>
              )}
              <FontAwesomeIcon
                icon={faGlobe}
                className="absolute top-1/2 right-0 transform -translate-y-1/2 pointer-events-none text-black"
              />
            </div>
            {/* change prefix from list */}
            {languages !== null && (
              <div className="dropdown-content">
                {languages?.map((code) => (
                  <button
                    key={code}
                    value={code}
                    className="drop"
                    onClick={(e) => {
                      i18n.changeLanguage(e.target.value);
                    }}
                  >
                    {code}
                  </button>
                ))}
              </div>
            )}
          </li>

          {!isMobile && calendar && calendar !== "no" && (
            <Link className="book-now-btn book-now-btn-margin" to={calendar}>
              Book Now
            </Link>
          )}

        </div>
      </ul>
    </div>
  );
}